var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"wagonElement",staticClass:"wagon",class:_vm.positioningClass,style:(`top:${_vm.offset}px`)},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }